
export const WaitingLoader = () => {
    return (
        <div className='page-loader'>
            <div />
        </div>
    );
}
